import axios from '../config/axios';

const API_BASE = '/location-hubs';

export const locationHubService = {
  // Get all hubs
  getAllHubs: (page = 1, perPage = 20, filters = {}) => {
    const params = {
      page,
      per_page: perPage,
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get hubs without pagination (for dropdowns)
  getHubsForSelect: (filters = {}) => {
    return axios.get(API_BASE, {
      params: {
        all: 'true',
        ...filters,
      },
    });
  },

  // Get single hub
  getHub: (hubId) => {
    return axios.get(`${API_BASE}/${hubId}`);
  },

  // Create hub
  createHub: (data, companyId = null) => {
    const payload = { ...data };
    if (companyId) {
      payload.company_id = companyId;
    }
    return axios.post(API_BASE, payload);
  },

  // Update hub
  updateHub: (hubId, data) => {
    return axios.put(`${API_BASE}/${hubId}`, data);
  },

  // Delete hub
  deleteHub: (hubId) => {
    return axios.delete(`${API_BASE}/${hubId}`);
  },

  downloadAttendanceQr: (hubId) => {
    return axios.get(`${API_BASE}/${hubId}/attendance-qr`, {
      responseType: 'blob',
    });
  },
};